import { AtSignIcon } from 'src/editor/shared/icons/at-sign-icon'
import { Building03Icon } from 'src/editor/shared/icons/building-03-icon'
import { Globe05Icon } from 'src/editor/shared/icons/globe-05-icon'
import { Hash02Icon } from 'src/editor/shared/icons/hash-02-icon'
import { Home03Icon } from 'src/editor/shared/icons/home-03-icon'
import { Mail02Icon } from 'src/editor/shared/icons/mail-02-icon'
import { MarkerPin01Icon } from 'src/editor/shared/icons/marker-pin-01-icon'
import { MarkerPin06Icon } from 'src/editor/shared/icons/marker-pin-06-icon'
import { Percent03Icon } from 'src/editor/shared/icons/percent-03-icon'
import { PhoneIcon } from 'src/editor/shared/icons/phone-icon'
import { UserLeft01Icon } from 'src/editor/shared/icons/user-left-01-icon'
import { UserRight01Icon } from 'src/editor/shared/icons/user-right-01-icon'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'

export const getFormSubentitiesSettingsIcons = (slug: ContactSlugEnum) => {
  switch (slug) {
    case ContactSlugEnum.Email:
      return AtSignIcon
    case ContactSlugEnum.FirstName:
      return UserLeft01Icon
    case ContactSlugEnum.Surname:
      return UserRight01Icon
    case ContactSlugEnum.Country:
      return Globe05Icon
    case ContactSlugEnum.City:
      return MarkerPin01Icon
    case ContactSlugEnum.Neighborhood:
      return Home03Icon
    case ContactSlugEnum.StreetAddress:
      return MarkerPin06Icon
    case ContactSlugEnum.StreetNumber:
      return Hash02Icon
    case ContactSlugEnum.CompanyName:
      return Building03Icon
    case ContactSlugEnum.Postcode:
      return Mail02Icon
    case ContactSlugEnum.PhoneNumber:
      return PhoneIcon
    case ContactSlugEnum.TaxNumber:
      return Percent03Icon
    case ContactSlugEnum.State:
      return MarkerPin01Icon
  }
}
